<script setup lang="ts">
import useSwr from "@/core/composables/swr/useSwr";
import {supportProgramApi} from "@/container";
import {SupportProgramIndexResource} from "@/core/http/resources/SupportProgramResource";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/core/components/ui/select";
import {cn} from "@/lib/utils";
import TagService from "@/tag/services/TagService";
import TagsIcon from "@/tag/components/TagsIcon.vue";
import {computed} from "vue";
import {ProgramBookable} from "@/program/interfaces/ProgramBookable";
import {AcceptableValue} from "reka-ui";

const model = defineModel<ProgramBookable | null>();
const props = defineProps<{
    inputClass?: HTMLElement['className'];
    supportPrograms?: SupportProgramIndexResource[];
}>();

const {data} = useSwr(!props.supportPrograms ? 'support-programs' : undefined, () => supportProgramApi().index());

const bookers = computed(() => {
    if (data.value?.length) {
        return data.value.flatMap(program => program.bookers);
    } else if (props.supportPrograms && props.supportPrograms?.length) {
        return props.supportPrograms.flatMap(program => program.bookers);
    }

    return [];
});

const getSupportProgram = (bookerId: number): SupportProgramIndexResource | null => {
    const programs = props.supportPrograms ?? data.value;

    return programs.find(program => !!program.bookers.find(booker => booker.id === bookerId)) || null;
};

/**
 * Update the model.
 */
const handleSelected = (value: AcceptableValue) => {
    const selectedBooker = bookers.value.find((booker: ProgramBookable) => booker.id.toString() === value);

    if (selectedBooker) {
        model.value = selectedBooker;
    } else {
        model.value = null;
    }
};
</script>

<template>
  <Select :model-value="model?.id.toString()" @update:model-value="handleSelected">
    <SelectTrigger :class="cn('w-full', inputClass)">
      <SelectValue placeholder="Rendez vous" />
    </SelectTrigger>
    <SelectContent>
      <SelectItem
        v-for="booker in (bookers)" :key="booker.id"
        :value="booker.id.toString()"
      >
        <div class="flex items-center">
          <div
            v-if="getSupportProgram(booker.id) && TagService.firstIconForTags((getSupportProgram(booker.id) as SupportProgramIndexResource).tags)"
            class="mr-1">
            <TagsIcon :tags="(getSupportProgram(booker.id) as SupportProgramIndexResource).tags" />
          </div>
          <span>{{ booker.title }}</span>
        </div>
      </SelectItem>
    </SelectContent>
  </Select>
</template>

<style scoped>

</style>
